import Box from "@mui/material/Box";
import { TabbedShowLayout, useStore } from "react-admin";
import { isAsharaEvent } from "@/utils";
import type { CurrentEvent } from "@/containers/events/types";
import { NiyaazShowInformationTab } from "./NiyaazShowInformationTab";
import { NiyaazShowPeopleSection, NiyaazShowReceiptsSection } from "./NiyaazShowSections";

export const NiyaazShowContent = () => {
  const [currentEvent] = useStore<CurrentEvent | null>("currentEvent", null);
  const isAshara = isAsharaEvent(currentEvent ?? undefined);

  return (
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="Information">
        <NiyaazShowInformationTab isAshara={isAshara} />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Family Members" path="family">
        <Box sx={{ maxWidth: 1200, pb: 2 }}>
          <NiyaazShowPeopleSection isAshara={isAshara} />
        </Box>
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Receipts" path="receipts">
        <Box sx={{ maxWidth: 1200, pb: 2 }}>
          <NiyaazShowReceiptsSection />
        </Box>
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  );
};
